import { render, staticRenderFns } from "./tree-list.vue?vue&type=template&id=afc4d100&scoped=true&"
import script from "./tree-list.vue?vue&type=script&lang=js&"
export * from "./tree-list.vue?vue&type=script&lang=js&"
import style0 from "./tree-list.vue?vue&type=style&index=0&id=afc4d100&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc4d100",
  null
  
)

export default component.exports